window.addEventListener('popstate', () => {
  window.dispatchEvent(new CustomEvent('changestate', { detail: { method: 'pop' }}))
})

export function triggerPageView() {
  window.dataLayer = window.dataLayer || {}

  window.dataLayer.push({ event: 'pageview' })
}

export default function updateHistory(path, options = {}) {
  const method = options.method || 'push'
  const state = options.state || null
  const shouldTriggerPageView = options.shouldTriggerPageView || false

  if (options.method === 'replace') {
    history.replaceState(state, null, path)
    window.dispatchEvent(new CustomEvent('replacestate'))
  } else {
    history.pushState(state, null, path)
    window.dispatchEvent(new CustomEvent('pushstate'))
  }

  window.dispatchEvent(new CustomEvent('changestate', { detail: { method, ...options.detail }}))

  shouldTriggerPageView && triggerPageView()
}
